document.addEventListener("DOMContentLoaded", function () {
  attachAddToCartListeners();
  attachDropdownListeners(); // Ensure dropdown listeners are attached initially

  // function openCartDrawerAndCheckVariant(currentVariantId) {
  //   const cartDrawer = document.querySelector(".drawer__inner");
  //   if (cartDrawer) {
  //     fetch("/cart.js")
  //       .then((response) => response.json())
  //       .then((cart) => {
  //         const variantIdsInCart = cart.items.map((item) => item.id);
  //         if (variantIdsInCart.includes(currentVariantId)) {
  //         } else {
  //           $("body").addClass("overflow-hidden");
  //           $(".drawer").addClass("animate active");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching cart data:", error);
  //       });
  //   }
  // }
  // window.addEventListener("load", () => {
  //   const currentVariantId = document.querySelector("input[name='id']").value; // Get the current variant ID from the form
  //   fetch("/cart.js")
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       if (cart.item_count > 0) {
  //         // Check if there are items in the cart
  //         openCartDrawerAndCheckVariant(currentVariantId); // Open the cart drawer and check variant
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching cart data:", error);
  //     });
  // });

  // // Attach the listener to the product page "Add to Cart" form
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // Prevent the form from submitting the traditional way

      const formData = new FormData(form); // Collect form data

      // Perform the AJAX call to add the product to the cart
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Product added to cart:", data);

          const customdrawer = document.querySelector(".custom-drawer");
          customdrawer.classList.add("active");
          customdrawer.classList.add("animate");
          updateCartDrawer();
          // checkCartAndManageProduct();
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
        });
    });
  });

  function attachAddToCartListeners() {
    const addToCartButtons = document.querySelectorAll(".upsell_addtocart_btn");

    addToCartButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        const productDiv = button.closest(".product-cart");
        const variantId = productDiv.getAttribute("data-limitLine");
        if (variantId) {
          addToCart(variantId);
        } else {
          console.error("Variant ID is not set.");
        }
      });
    });
  }

  function addToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Call updateCartDrawer to refresh the cart
        updateCartDrawer();
        console.log("Cart Updated: ", data);
        const customDrawer = document.querySelector(".custom-drawer");
        customDrawer.classList.remove("is-empty");
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  function updateCartDrawer() {
    fetch(window.location.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newCartDrawer = doc.querySelector(".drawer__inner");
        const currentCartDrawer = document.querySelector(".drawer__inner");
        if (currentCartDrawer && newCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

          // Detach old listeners before reattaching
          detachAddToCartListeners();
          detachDropdownListeners();

          attachAddToCartListeners();
          attachDropdownListeners(); // Reattach dropdown listeners after cart update
          // Check the cart and manage the free product after updating the cart drawer
          // checkCartAndManageProduct();

          const loader = document.querySelector("cart-drawer-items .loader");
          loader.classList.remove("hidden");
          setTimeout(function () {
            loader.classList.add("hidden");
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error fetching the cart drawer:", error);
      });
  }
  function attachDropdownListeners() {
    const dropdowns = document.querySelectorAll(".variant-dropdown");
    console.log("Attaching listeners to dropdowns:", dropdowns.length); // Log number of dropdowns found

    // Loop through each dropdown
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("change", function () {
        const selectedValue = this.value;

        // Find the parent product container
        const productDiv = this.closest(".product-cart");
        if (productDiv) {
          // Set data-limitLine attribute with selected value
          productDiv.setAttribute("data-limitLine", selectedValue);
        }

        // Get selected option's image URL and price
        const selectedOption = dropdown.options[dropdown.selectedIndex];
        const newImgUrl = selectedOption.getAttribute("data-img");
        const newPrice = selectedOption.getAttribute("data-price");
        const newComparePrice = selectedOption.getAttribute("data-compareprice");

        // Find the closest product container again for updating image and price
        if (productDiv) {
          // Update product image
          const productImage = productDiv.querySelector(".product_img img");
          if (productImage && newImgUrl) {
            productImage.src = newImgUrl;
          }

          // Update product price if you need to (you can modify this part to update the price in the DOM)
          const productPrice = productDiv.querySelector(".update_price");
          if (productPrice && newPrice) {
            productPrice.textContent = newPrice;
          }
          const productComparePrice = productDiv.querySelector(".upsell_compare_price");
          if (productComparePrice && newComparePrice) {
            productComparePrice.textContent = newComparePrice;
          }
        }
      });
    });
  }

  const variantIdGift1 = 50886107365705; // Replace with the variant ID for the first gift (sleep mask)
  const variantIdGift2 = 51259249426761; // Replace with the variant ID for the second gift (pillow)



let gift1AlreadyAdded = false;
let gift2AlreadyAdded = false;

function checkCartAndManageProduct() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      const cartTotal = data.total_price; // Total cart price in cents
      const thresholdGift1 = 8000; // $80 in cents
      const thresholdGift2 = 20000; // $200 in cents

      const gift1InCart = data.items.some((item) => item.variant_id === variantIdGift1);
      const gift2InCart = data.items.some((item) => item.variant_id === variantIdGift2);

      // Manage Gift 1
      if (cartTotal >= thresholdGift1 && !gift1InCart && !gift1AlreadyAdded) {
        console.log("Adding first gift (sleep mask) to cart...");
        addProductToCart(variantIdGift1);
        gift1AlreadyAdded = true; // Prevent multiple additions
      } else if (cartTotal < thresholdGift1 && gift1InCart && gift1AlreadyAdded) {
        console.log("Removing first gift (sleep mask) from cart...");
        removeProductFromCart(variantIdGift1);
        gift1AlreadyAdded = false; // Reset the flag when removed
      }

      // Manage Gift 2
      if (cartTotal >= thresholdGift2 && !gift2InCart && !gift2AlreadyAdded) {
        console.log("Adding second gift (pillow) to cart...");
        addProductToCart(variantIdGift2);
        gift2AlreadyAdded = true; // Prevent multiple additions
      } else if (cartTotal < thresholdGift2 && gift2InCart && gift2AlreadyAdded) {
        console.log("Removing second gift (pillow) from cart...");
        removeProductFromCart(variantIdGift2);
        gift2AlreadyAdded = false; // Reset the flag when removed
      }

      // Re-fetch cart to get updated data after adding/removing gifts
      return fetch("/cart.js");
    })
    .then((response) => response.json())
    .then((data) => {
      let totalDiscount = 0; // Initialize total discount
      const cartItems = document.querySelectorAll(".cart-item"); // Select all cart items

      // Loop through each cart item
      cartItems.forEach((item) => {
        const oldPriceElement = item.querySelector(".cart-item__old-price");

        // Check if the item has an old price
        if (oldPriceElement) {
          const priceText = oldPriceElement.textContent.trim().replace(/[^0-9.-]+/g, ""); // Remove currency symbol and extra characters
          const priceValue = parseFloat(priceText); // Parse the price value

          // Add the price to totalDiscount if it's a valid number
          if (!isNaN(priceValue)) {
            totalDiscount += priceValue;
          }
        }
      });

      // Function to format number to EUR style without the currency symbol
      function formatDiscount(value) {
        return (value / 100).toFixed(2).replace(".", ","); // This formats the number correctly
      }

      // Display the total discount
      const discountElement = document.querySelector(".cart-discount");
      const kortingElement = document.querySelector(".totals_dispatch_Korting"); // Select the Korting header
      if (discountElement) {
        if (totalDiscount > 0) {
          discountElement.textContent = formatDiscount(totalDiscount); // Display only the discount price
          discountElement.style.display = "block"; // Show the discount element
          kortingElement.style.display = "block"; // Show the Korting header when discount is present
        } else {
          discountElement.style.display = "none"; // Hide if no discount
          kortingElement.style.display = "none"; // Hide Korting header if no discount
        }
      }

      console.log("Total discount calculated:", totalDiscount);
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
}


  // Function to check if a product is already in the cart
  function isProductInCart(variantId) {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data.items.some((item) => item.variant_id === variantId);
      })
      .catch((error) => {
        console.error("Error checking cart:", error);
        return false;
      });
  }

  // Function to add a product to the cart
  function addProductToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Product added to cart:", data);
        updateCartDrawer(); // Refresh the cart drawer
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  function removeProductFromCart(variantId) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        // Find the cart item by variant ID
        const item = data.items.find((item) => item.variant_id === variantId);

        if (item) {
          // Prepare the request to remove the product by setting quantity to 0
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: item.key, // Use item.key from the cart.js response
              quantity: 0, // Set the quantity to 0 to remove the item
            }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Failed to remove product from cart.");
              }
              return response.json();
            })
            .then((updatedCart) => {
              console.log("Product removed from cart:", updatedCart);
              gift1AlreadyAdded = false;
              gift2AlreadyAdded = false;
              updateCartDrawer(); // Refresh the cart drawer
            })
            .catch((error) => {
              console.error("Error removing product from cart:", error);
            });
        } else {
          console.warn("Product not found in cart for removal.");
        }
      })
      .catch((error) => {
        console.error("Error fetching cart data for removal:", error);
      });
  }

  function detachAddToCartListeners() {
    const addToCartButtons = document.querySelectorAll(".upsell_addtocart_btn");
    addToCartButtons.forEach(function (button) {
      const newButton = button.cloneNode(true);
      button.replaceWith(newButton);
    });
  }

  function detachDropdownListeners() {
    const dropdowns = document.querySelectorAll(".variant-dropdown");
    dropdowns.forEach(function (dropdown) {
      const newDropdown = dropdown.cloneNode(true);
      dropdown.replaceWith(newDropdown);
    });
  }

  const cartDrawer = document.querySelector(".drawer__inner");
  console.log("cartDrawer", cartDrawer);
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      checkCartAndManageProduct();
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  checkCartAndManageProduct();
});
